module.exports = __webpack_public_path__ + "static/beckoning-will-o-wisp_mtg_clb-0de2e2fa481f0e79b3b7d45457a0f4cd.webp";